import { useEffect, useState } from 'react';
import moment from 'moment-timezone';

import { PostUser, LanguageOption } from '@umanforge/common';
import { ModifyUser } from 'interfaces/api_user.interfaces';

import { MAX_LENGTH_ENTITY } from 'constants/limite.constants';

import { Input } from '../../components/inputs/input.component';
import { LanguageSelector } from '../../components/menu/language_selector.component';
import { Select } from '../../components/inputs/select.component';

import { FirstnameIcon } from '../../components/icons/firstname_icon.component';
import { LastnameIcon } from '../../components/icons/lastname_icon.component';
import { EmailIcon } from '../../components/icons/email_icon.component';
import { LanguageIcon } from '../../components/icons/language_icon.component';
import { TimezoneIcon } from '../../components/icons/timezone_icon.component';
import { GlobalService } from 'services/global.service';


interface AddUserFiledsProps {
  postUser: PostUser;
  defaultLanguage: LanguageOption | undefined;
  defaultTimezone: { value: string, label: string; } | undefined;
  onUserChange: ( user: ModifyUser ) => void;
  t: ( key: string ) => string;
}

export function AddUserFileds( { postUser, defaultLanguage, defaultTimezone, onUserChange, t }: AddUserFiledsProps ) {

  const TIMEZONES = moment.tz.names().map( tz => { return { value: tz, label: tz }; } );

  const [ modifyUser, setModifyUser ] = useState<ModifyUser>( {
    email: postUser.email,
    firstname: postUser.firstname,
    lastname: postUser.lastname,
    language: defaultLanguage?.value,
    timezone: defaultTimezone?.label
  } );

  useEffect( () => {
    onUserChange( modifyUser );
  }, [ modifyUser ] );

  return (
    <div className='flex flex-col max-w-[550px] xl:max-w-[800px] w-full h-full gap-4'>
      <div className='flex gap-4'>
        <Input
          required
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_FIRSTNAME }
          label={ t( 'firstname' ) }
          value={ postUser.firstname }
          onChange={ newFirstname => {
            modifyUser.firstname = newFirstname != '' ? newFirstname : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='Jean'
          icon={ <FirstnameIcon className='w-8 h-8'/> }
        />
        <Input
          required
          onlyUpperCase
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_LASTNAME }
          label={ t( 'Lastname' ) }
          value={ postUser.lastname }
          onChange={ newLastname => {
            modifyUser.lastname = newLastname != '' ? newLastname : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='DUPONT'
          icon={ <LastnameIcon className='w-8 h-8'/> }
        />
      </div>
      <div className='flex flex-col gap-4 '>
        <Input
          required
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_EMAIL }
          label={ t( 'Email' ) }
          value={ postUser.email }
          checkContent={ email => { return GlobalService.validateEmail( email ) ? null : t( 'please_enter_a_valid_email_address' ); } }
          onChange={ newEmail => {
            modifyUser.email = newEmail != '' ? newEmail : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='jean.dupont@exemple.com'
          icon={ <EmailIcon className='w-8 h-8'/> }
        />
        <div className='w-full'>
          <span>{ t( 'Language' ) }</span>
          <LanguageSelector
            value={ defaultLanguage }
            onChange={ newLang => {
              modifyUser.language = newLang.value;
              setModifyUser( structuredClone( modifyUser ) );
            } }
            menuPlacement='bottom'
            icon={ <LanguageIcon className='w-8 h-8'/> }
          />
        </div>
        <Select
          required
          label={t( 'Time zone' )}
          value={ defaultTimezone }
          options={ TIMEZONES }
          onChange={ newTimeZone => {
            modifyUser.timezone = newTimeZone.value;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          icon={ <TimezoneIcon className='w-8 h-8'/> }
        />
      </div>
    </div>
  );
}